var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: { model: _vm.form, "label-position": "top", size: "small" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.Airline"),
                        prop: "configCode",
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("collectionCenter.notNull"),
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                            remote: "",
                            "remote-method": _vm.getAirlineOption,
                          },
                          on: { "visible-change": _vm.getAirlineOptionChange },
                          model: {
                            value: _vm.form.configCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "configCode", $$v)
                            },
                            expression: "form.configCode",
                          },
                        },
                        _vm._l(_vm.airlineOptions, function (item) {
                          return _c("el-option", {
                            key: item.configCode,
                            attrs: {
                              label: item.airlineName,
                              value: item.configCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _vm.pushType === 0
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.MDFEKey"),
                            prop: "mdfeKey",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                              {
                                pattern: /^[a-zA-Z0-9]{44}$/,
                                message: _vm.$t(
                                  "mdfeTranslate.PleaseEnterA44DigitKey"
                                ),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              maxlength: "44",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.mdfeKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mdfeKey", $$v)
                              },
                              expression: "form.mdfeKey",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pushType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.MDFEKey"),
                            prop: "mdfeKey",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "mdfeTranslate.PleaseEnterMDFeKey"
                              ),
                              type: "textarea",
                              rows: 6,
                            },
                            model: {
                              value: _vm.form.mdfeKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mdfeKey", $$v)
                              },
                              expression: "form.mdfeKey",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }